import React, { useRef, useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { RootReducerState } from 'reduxStore/rootReducers';
import { generateSlug, UrlFirstSegment } from 'utils/global';
import logo from 'assets/images/svg/logo.svg';
import { serviceType } from 'utils/constants';
import GlobalSearch from './GlobalSearch';
import { BASE_URI, FILE_BASE_URI } from 'reduxStore/apiEndPoints';
import { loadable } from 'react-lazily/loadable';
const { TranslationMessage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { Image } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});

interface Props {}

const SubHeader = (props: Props) => {
	const [activeData, setActiveData] = useState<any>({});
	const urlFirstSegment = UrlFirstSegment();
	const { navigationMenuData, rightButtonMenuData, footerData } = useSelector(
		({ menuReducer, siteSettingReducer }: RootReducerState) => ({
			navigationMenuData: menuReducer.navigationMenuData,
			rightButtonMenuData: menuReducer.rightButtonMenuData,
			footerData: siteSettingReducer.data,
		}),
		shallowEqual
	);

	const history = useHistory();

	//START OUTSIDE CLICK
	const myNavigationRef = useRef<any>();

	const lottieRef = useRef<any>(null);
	const lottieContainerRef = useRef<any>();

	const handleClickAnimation = () => {
		if (lottieRef.current) {
			lottieRef.current.goToAndPlay(0, true);
		}
	};

	const handleClickOutside = (e) => {
		if (!myNavigationRef.current.contains(e.target)) {
			const cloneData = activeData;
			let data = Object.keys(cloneData) // Get list of keys
				.reduce((result, k) => {
					// Reduce keys to object of key/value pairs
					// where key match is set to true
					return { ...result, [k]: false };
				}, {});
			setActiveData(data);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	});

	//STOP OUTSIDE CLICK
	const toggleNaviagtion = (name: string) => {
		const cloneData = activeData;
		if (!cloneData.hasOwnProperty(name)) {
			cloneData[name] = false;
		}
		let data = Object.keys(cloneData) // Get list of keys
			.reduce((result, k) => {
				// Reduce keys to object of key/value pairs
				// where key match is set to true
				return { ...result, [k]: name === k && !cloneData[k] };
			}, {});
		setActiveData(data);
	};

	const generateLink = (item) => {
		// if (validURL(item.menu_url))
		if (String(item.menu_url).includes('http'))
			return (
				<a href={item.menu_url} target="_blank">
					<TranslationMessage data={item} value="menu_title" />{' '}
				</a>
			);
		else
			return (
				<NavLink to={item.menu_url} activeClassName="active" onClick={() => toggleNaviagtion('all')}>
					<TranslationMessage data={item} value="menu_title" />
				</NavLink>
			);
	};

	const megamenuBannerLink = (item) => {
		if (String(item.featured_image_url).includes('http'))
			return (
				<a href={item.featured_image_url} target="_blank">
					<div className="dropdown-img-holder">
						<h4>
							<TranslationMessage data={item} value="featured_image_text" />
						</h4>
						<img
							src={item?.featured_image ? FILE_BASE_URI + item.featured_image : null}
							className="dropdown-img img-fluid w-100 rounded"
							alt={item?.featured_image_text ? item.featured_image_text : 'Nabil Bank'}
							title={item?.featured_image_text ? item.featured_image_text : 'Nabil Bank'}
						/>
					</div>
				</a>
			);
		else
			return (
				<Link to={item.featured_image_url} onClick={() => toggleNaviagtion('all')}>
					<div className="dropdown-img-holder">
						<h4>
							<TranslationMessage data={item} value="featured_image_text" />
						</h4>
						<img
							src={item?.featured_image ? FILE_BASE_URI + item.featured_image : null}
							className="dropdown-img img-fluid w-100 rounded"
							alt={item?.featured_image_text ? item.featured_image_text : 'Nabil Bank'}
							title={item?.featured_image_text ? item.featured_image_text : 'Nabil Bank'}
						/>
					</div>
				</Link>
			);
	};

	const renderClass = () => {
		if (urlFirstSegment === serviceType.HOME) {
			return 'layout1';
		} else if (urlFirstSegment === serviceType.NABIL) {
			return 'layout1';
		} else if (urlFirstSegment === serviceType.INDIVIDUAL) {
			return 'layout2';
		} else if (urlFirstSegment === serviceType.BUSINESS) {
			return 'layout2';
		} else if (urlFirstSegment === serviceType.SERVICESANDPAYMENTS) {
			return 'layout3';
		}
	};

	const renderStyle = (data) => {
		let parent: any = 0;
		let children: any = 0;
		data?.submenu.map((x) => {
			++parent;
			x.submenu.map((y) => ++children);
		});

		let total = parent + children;
		if (total > 18) return 'above18';
		else if (total > 9) return 'above9';
		else return 'below9';
		// if (total > 18) return { columnCount: 3, minHeight: "100%", maxHeight: "100%" };
		// else if (total > 9) return { columnCount: 2 };
		// else return { columnCount: 1, maxHeight: "100%" };
	};

	return (
		<React.Fragment>
			<div className="navigation-bottom d-flex justify-content-between  position-relative">
				<NavLink to={`/`} className="py-3">
					<figure className="mb-0" style={{ minWidth: '175px' }}>
						<Image className="img-fluid" src={footerData?.site_logo} alt="logo" onErrorSrc={logo} width="175" />
					</figure>
				</NavLink>

				<div className="d-flex align-items-center" ref={myNavigationRef}>
					{/* NAGIVATION MENU */}
					<ul className={`d-flex align-items-center list-unstyled mb-0 ${'hover-underline'}`}>
						{navigationMenuData.map((navigationItem, index) => {
							let state = generateSlug(navigationItem.menu_title);
							const findHiddenItems = navigationItem.submenu.find((obj) => obj?.hide_in_website === 'no');
							return (
								navigationItem.hide_in_website === 'no' && (
									<li className="hasdropdown py-3" key={index}>
										<a
											href={navigationItem.submenu.length > 0 && findHiddenItems !== undefined ? '#' : navigationItem.menu_url}
											// href={void 0}
											onClick={(e) => {
												if (navigationItem.submenu.length > 0 && findHiddenItems !== undefined) {
													e.preventDefault();
												} else {
													history.push(navigationItem.menu_url);
												}
												toggleNaviagtion(state);
											}}
											className={`d-block px-3 ${activeData?.[state] ? 'dropdown-active' : ''}`}
										>
											<TranslationMessage data={navigationItem} value="menu_title" />
										</a>

										{/* {isShown && ( */}
										{navigationItem?.submenu.length > 0 && findHiddenItems !== undefined && (
											<div className={`megamenu-dropdown ${renderClass()}`}>
												<div className="row">
													<div className="col-md-8">
														{/* <ul style={renderStyle(navigationItem)} className={`megamenu-dropdown-ul ${renderStyle(navigationItem)}`}> */}
														<ul className={`megamenu-dropdown-ul ${renderStyle(navigationItem)}`}>
															{navigationItem?.submenu.map(
																(subitem, subindex) =>
																	subitem.hide_in_website === 'no' && (
																		<li className="dropdown-item" key={subindex}>
																			<NavLink to={subitem.menu_url} className="dropdown-link" onClick={() => toggleNaviagtion('all')}>
																				{/* <a className=" dropdown-link"> */}
																				<TranslationMessage data={subitem} value="menu_title" />
																				{/* </a> */}
																			</NavLink>
																			<ul className="dropdown dropdown-sublist list-unstyled">
																				{subitem?.submenu.map((sitem, sindex) => (
																					<li key={sindex} className="position-relative">
																						{generateLink(sitem)}
																						{/* <div className="megablinkoffertag">New</div> */}
																					</li>
																				))}
																			</ul>
																		</li>
																	)
															)}
														</ul>
													</div>
													{navigationItem?.featured_image && navigationItem?.featured_image_text ? <div className="col-md-4">{megamenuBannerLink(navigationItem)}</div> : null}
												</div>
											</div>
										)}
									</li>
								)
							);
						})}
					</ul>

					{/* TOP RIGHT BUTTON MENU */}
					{rightButtonMenuData.map((rightButton, rbIndex) => {
						let state = generateSlug(rightButton.menu_title);
						return (
							rightButton.hide_in_website === 'no' && (
								<div className="navigation-dropdown" key={rbIndex}>
									<button
										className="btn btn-md btn-outline-success mx-2"
										onClick={(e) => {
											e.preventDefault();
											toggleNaviagtion(state);
										}}
									>
										{rightButton?.icon_type === 'class' && rightButton?.menu_icon && <i className={rightButton?.menu_icon}></i>}
										{rightButton?.icon_type === 'image' && rightButton?.menu_image && <img src={rightButton?.menu_image} />}

										<span className="ml-1 with-arrow">
											<TranslationMessage data={rightButton} value="menu_title" />
										</span>
									</button>

									{activeData?.[state] && (
										<ul className="navigation-dropdown-links">
											{rightButton.submenu.map((subRightButton, srbIndex) => subRightButton.hide_in_website === 'no' && <li key={srbIndex}>{generateLink(subRightButton)}</li>)}
										</ul>
									)}
								</div>
							)
						);
					})}

					{/* Global Search */}
					<GlobalSearch isSearchActive={activeData.searchDropdown} toggleNaviagtion={toggleNaviagtion} />
				</div>
			</div>
		</React.Fragment>
	);
};

export default SubHeader;
